interface DocumentFilterTabsProps {
  selectedDocType: string;
  onTabClick: (tabName: string) => void;
}

const DocumentFilterTabs = ({ selectedDocType, onTabClick }: DocumentFilterTabsProps) => {
  const tabs = ["סימוכין", "פסיקה רלוונטית", "חקיקה רלוונטית"];

  return (
    <div className="flex min-w-0 items-center gap-3 overflow-x-auto md:gap-6">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabClick(tab)}
          className={`shrink-0 whitespace-nowrap text-sm font-medium transition-colors pb-2 ${
            selectedDocType === tab
              ? "text-indigo-500 border-b-2 border-indigo-500"
              : "text-slate-400 hover:text-slate-600"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default DocumentFilterTabs;
